import { Component, inject } from '@angular/core';
import { FileListComponent } from './file-list/file-list.component';
import { FileService } from '../../service/file.service';
import { FileStore } from '../../stores/file.store';
import { FileSignature, OriginalFileNameModel } from '../../types/file-signature';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-file-download',
  standalone: true,
  imports: [FileListComponent],
  templateUrl: './file-download.component.html',
  styleUrl: './file-download.component.scss'
})
export class FileDownloadComponent {

resultText = "";
signature: string | null = null;
containerName: string | null = null;
targetFileGuid: string | null = null;
accessCode = '';
fileSignatureInfo: FileSignature | null = null;
fileName = "";
downloadUrl = "";
originFileNameList: OriginalFileNameModel[] = [];

private _subscription = new Subscription();
private _fileService = inject(FileService);
private _fileStore = inject(FileStore);
private _router = inject(Router);

  ngOnInit(): void {
    this.getStoreInfo();
    this.navigeteForValidarion(this.fileSignatureInfo!);
    this.downloadFile();
  }
  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  getStoreInfo() {
    this.signature = this._fileStore.getSignature();
    this.containerName = this._fileStore.getContainerName();
    this.targetFileGuid = this._fileStore.getTargetFileGuid();
    this.accessCode = this._fileStore.getAccessCode() ?? '';
    this.fileSignatureInfo = this._fileStore.getFileSignatureInfo();
  }

  downloadFile(): void {
    if (this.fileSignatureInfo && this.signature && this.containerName) {
      this._subscription.add(
        this._fileService.getFileDownloadSASUrl(this.containerName, this.signature, this.accessCode, this.targetFileGuid).subscribe({
          next: (fileSignatureResult: FileSignature) => {
            this._fileService.updateFileStoreFileSignatureInfo(fileSignatureResult);
            this.inputDisplayText(fileSignatureResult.downloadFileName!, fileSignatureResult.originalFileNameList || []);
            // ダウンロード用のページに遷移する
            this.updateDownloadInfoStore(fileSignatureResult.sasuri!, fileSignatureResult.downloadFileName!)
            this._router.navigate(['/download-helper']);
          },
          error: (error: FileSignature) => {
            console.error('Error downloading file:', error);
            this.navigeteForValidarion(error);
          }
        })
      );
    } else {
      console.error('FileSignatureInfo, signature, or containerName is null');
      this.resultText = 'ファイル情報が不正です。';
      // シグネチャ不正画面に遷移する
      this._router.navigate(['/error/invalid-signature']);
    }
  }

  updateDownloadInfoStore(sasuri: string, downloadFileName: string): void {
    this._fileStore.setSasUri(sasuri);
    this._fileStore.setDownloadFileName(downloadFileName);
  }

  inputDisplayText(fileName: string, originFileNameList: OriginalFileNameModel[]): void {
    this.fileName = fileName;
    this.resultText = 'ファイルのダウンロードが行われました。';
    this.originFileNameList = originFileNameList
    this._fileStore.setOriginalFileNames(originFileNameList);
  }

  navigeteForValidarion(result: FileSignature) {
    if (result === null) {
      return;
    }
    if (!result.isVerifiedSignature) {
      // シグネチャ不正画面に遷移する
      this._router.navigate(['/error/invalid-signature']);
    }
    if (result.isExpiredUrl) {
      // 有効期限切れ画面に遷移する
      this._router.navigate(['/error/expired']);
    }
    if (result.isLockedAccess) {
      // アクセス制限画面に遷移する
      this._router.navigate(['/error/lock']);
    }
    if (result.isManualDelete) {
      // 手動削除画面に遷移する
      this._router.navigate(['/error/invalid-url']);
    }
  }

}
